__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "forge";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-rum", "6.24.1", function() { return function() { return __webpack_require__(48953); }; }, 1);
			register("@tanstack/react-query", "5.90.11", function() { return function() { return __webpack_require__(62040); }; }, 1);
			register("axios", "1.13.2", function() { return function() { return __webpack_require__(84447); }; }, 1);
			register("i18next", "25.6.3", function() { return function() { return __webpack_require__(72635); }; }, 1);
			register("react-dom/client", "18.3.1", function() { return function() { return __webpack_require__(5338); }; }, 1);
			register("react-dom/server", "18.3.1", function() { return function() { return __webpack_require__(65848); }; }, 1);
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(40961); }; }, 1);
			register("react-i18next", "15.7.3", function() { return function() { return __webpack_require__(32389); }; }, 1);
			register("react-router-dom", "6.30.3", function() { return function() { return __webpack_require__(84976); }; }, 1);
			register("react-router", "6.30.3", function() { return function() { return __webpack_require__(47767); }; }, 1);
			register("react/jsx-runtime", "18.3.1", function() { return function() { return __webpack_require__(74848); }; }, 1);
			register("react", "18.3.1", function() { return function() { return __webpack_require__(96540); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};